


























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "axios";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import { markerModule } from "../store/markers";
import DrawerMixin from "@/mixins/drawer";
import { mixins } from "vue-class-component";
import { contextModule } from "@/store/context";
import ILabel from "@/types/label";
import MarkerCard from "@/components/MarkerCard.vue";

@Component({
  components: { MarkerCard },
})
export default class MarkerList extends mixins(DrawerMixin) {
  get showSidenav() {
    return contextModule.showSidenav;
  }

  markers = [] as any[];

  query = localStorage.getItem("pm_markerQuery") || "";

  sortDir = localStorage.getItem("pm_markerSortDir") || "desc";
  sortDirItems = [
    {
      text: "Ascending",
      value: "asc",
    },
    {
      text: "Descending",
      value: "desc",
    },
  ];

  sortBy = localStorage.getItem("pm_markerSortBy") || "relevance";
  sortByItems = [
    {
      text: "Relevance",
      value: "relevance",
    },
    {
      text: "A-Z",
      value: "name",
    },
    {
      text: "Added to collection",
      value: "addedOn",
    },
    {
      text: "Rating",
      value: "rating",
    },
    {
      text: "Bookmarked",
      value: "bookmark",
    },
    {
      text: "Random",
      value: "$shuffle",
    },
  ];

  ratingFilter = 0;
  favoritesOnly = false;
  bookmarksOnly = false;

  fetchError = false;
  fetchLoader = false;

  tryReadLabelsFromLocalStorage(key: string) {
    return (localStorage.getItem(key) || "").split(",").filter(Boolean) as string[];
  }

  allLabels = [] as ILabel[];

  selectedLabels = {
    include: this.tryReadLabelsFromLocalStorage("pm_markerInclude"),
    exclude: this.tryReadLabelsFromLocalStorage("pm_markerExclude"),
  };

  onSelectedLabelsChange(val: any) {
    localStorage.setItem("pm_markerInclude", val.include.join(","));
    localStorage.setItem("pm_markerExclude", val.exclude.join(","));
    this.refreshed = false;
  }

  set page(page: number) {
    markerModule.setPage(page);
  }

  get page() {
    return markerModule.page;
  }

  get numResults() {
    return markerModule.numResults;
  }

  get numPages() {
    return markerModule.numPages;
  }

  refreshed = true;

  resetPagination() {
    markerModule.resetPagination();
    this.refreshed = true;
    this.loadPage(this.page).catch(() => {
      this.refreshed = false;
    });
  }

  @Watch("query")
  onQueryChange(newVal: string | null) {
    localStorage.setItem("pm_markerQuery", newVal || "");
    this.refreshed = false;
  }

  @Watch("selectedLabels")
  onLabelChange() {
    this.refreshed = false;
  }

  @Watch("ratingFilter", {})
  onRatingChange(newVal: number) {
    localStorage.setItem("pm_markerRating", newVal.toString());
    this.refreshed = false;
  }

  @Watch("favoritesOnly")
  onFavoriteChange(newVal: boolean) {
    localStorage.setItem("pm_markerFavorite", "" + newVal);
    this.refreshed = false;
  }

  @Watch("bookmarksOnly")
  onBookmarkChange(newVal: boolean) {
    localStorage.setItem("pm_markerBookmark", "" + newVal);
    this.refreshed = false;
  }

  @Watch("sortDir")
  onSortDirChange(newVal: string) {
    localStorage.setItem("pm_markerSortDir", newVal);
    this.refreshed = false;
  }

  @Watch("sortBy")
  onSortChange(newVal: string) {
    localStorage.setItem("pm_markerSortBy", newVal);
    this.refreshed = false;
  }

  async fetchPage(page: number, take = 24, random?: boolean, seed?: string) {
    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: MarkerSearchQuery!, $seed: String) {
            getMarkers(query: $query, seed: $seed) {
              items {
                _id
                name
                time
                favorite
                bookmark
                rating
                scene {
                  name
                  _id
                }
                thumbnail {
                  _id
                }
              }
              numItems
              numPages
            }
          }
        `,
        variables: {
          query: {
            query: this.query,
            include: this.selectedLabels.include,
            exclude: this.selectedLabels.exclude,
            take,
            page: page - 1,
            sortDir: this.sortDir,
            sortBy: random ? "$shuffle" : this.sortBy,
            favorite: this.favoritesOnly,
            bookmark: this.bookmarksOnly,
            rating: this.ratingFilter,
          },
          seed: seed || localStorage.getItem("pm_seed") || "default",
        },
      });

      return result.data.getMarkers;
    } catch (err) {
      throw err;
    }
  }

  refreshPage() {
    this.loadPage(markerModule.page);
  }

  loadPage(page: number) {
    this.fetchLoader = true;

    return this.fetchPage(page)
      .then((result) => {
        this.fetchError = false;
        markerModule.setPagination({
          numResults: result.numItems,
          numPages: result.numPages,
        });
        this.markers = result.items;
      })
      .catch((err) => {
        console.error(err);
        this.fetchError = true;
      })
      .finally(() => {
        this.fetchLoader = false;
      });
  }

  mounted() {
    if (!this.markers.length) this.refreshPage();
  }

  beforeMount() {
    ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
            aliases
          }
        }
      `,
    })
      .then((res) => {
        this.allLabels = res.data.getLabels;
        if (!this.allLabels.length) {
          this.selectedLabels.include = [];
          this.selectedLabels.exclude = [];
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
